import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'

const LoginView = () => import("../views/Login")
const LogoutView = () => import("../views/Logout")

const Home = () => import("../views/Home")

const CreateMission = () => import("../views/mission/CreateMission")
const CreateLeg = () => import("../views/mission/CreateLeg")
const MissionDetails = () => import("../views/mission/MissionDetails")
const MissionBilling = () => import("../views/mission/MissionBilling")
const LegsList = () => import("../views/leg/LegsList")
const ModifyLeg = () => import("../views/mission/ModifyLeg")
const MissionRequestDetails = () => import("../views/missionrequest/MissionRequestDetails")
const MissionRequestsList = () => import("../views/missionrequest/MissionRequestsList")
const CreateMissionRequest = () => import("../views/missionrequest/CreateMissionRequest")
const FleetAircraftsList = () => import("../views/fleet/AircraftsList")
const EmptyLegDetails = () => import("../views/emptyleg/EmptyLegDetails")
const EmptyLegsList = () => import("../views/emptyleg/EmptyLegsList")
const FleetAircraftDetails = () => import("../views/fleet/AircraftDetails")
const FleetOperatorsList = () => import("../views/fleet/OperatorsList")
const FleetOperatorDetails = () => import("../views/fleet/OperatorDetails")
const FleetOutreachDashboard = () => import("../views/fleet/OutreachDashboard")
const ClientDetails = () => import("../views/client/ClientDetails")
const ClientsList = () => import("../views/client/ClientsList")
const CreateClient = () => import("../views/client/CreateClient")
const ModifyClient = () => import("../views/client/ModifyClient")

// Jetcard
const JetcardsList = () => import("../views/jetcard/JetcardsList")
const CreateJetcard = () => import("../views/jetcard/CreateJetcard")
const ModifyJetcard = () => import("../views/jetcard/ModifyJetcard")
const JetcardDetails = () => import("../views/jetcard/JetcardDetails")

// Mobility
const MobilityCardsList = () => import("../views/mobility/MobilityCardsList")
const CreateMobilityCard = () => import("../views/mobility/CreateMobilityCard")
const ModifyMobilityCard = () => import("../views/mobility/ModifyMobilityCard")
const MobilityCardDetails = () => import("../views/mobility/MobilityCardDetails")

const StatisticsPage = () => import("../views/StatisticsPage")
const PromptsPage = () => import("../views/PromptsPage")
const IntelligenceBaseList = () => import("../views/intelligence/IntelligenceBaseList")
const CreateIntelligenceBase = () => import("../views/intelligence/CreateIntelligenceBase")
const ModifyIntelligenceBase = () => import("../views/intelligence/ModifyIntelligenceBase")

// Service Providers
const ServiceProvidersList = () => import("../views/service_provider/ServiceProvidersList")
const ServiceProviderDetails = () => import("../views/service_provider/ServiceProviderDetails")
const CreateServiceProvider = () => import("../views/service_provider/CreateServiceProvider")
const ModifyServiceProvider = () => import("../views/service_provider/ModifyServiceProvider")


Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}


const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/legs',
    name: 'legs-list',
    component: LegsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/fleet/aircrafts',
    name: 'fleet-aircrafts',
    component: FleetAircraftsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/fleet/aircrafts/:id',
    name: 'fleet-aircrafts-details',
    component: FleetAircraftDetails,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/fleet/operators',
    name: 'fleet-operators',
    component: FleetOperatorsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/empty-legs',
    name: 'empty-legs',
    component: EmptyLegsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/empty-legs/:id',
    name: 'empty-leg-details',
    component: EmptyLegDetails,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/fleet/outreach',
    name: 'fleet-outreach',
    component: FleetOutreachDashboard,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/fleet/operators/:id',
    name: 'fleet-operators-details',
    component: FleetOperatorDetails,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/clients/:id/mission-requests/create',
    name: 'mission-requests-create',
    component: CreateMissionRequest,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/mission-requests',
    name: 'mission-requests-list',
    component: MissionRequestsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/mission-requests/:id',
    name: 'mission-requests-details',
    component: MissionRequestDetails,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/missions/:id',
    name: 'missions-details',
    component: MissionDetails,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/missions/:id/billing',
    name: 'missions-billing',
    component: MissionBilling,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/missions/:id/legs/create',
    name: 'missions-leg-create',
    component: CreateLeg,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/jetcards',
    name: 'jetcards',
    component: JetcardsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/jetcards/create',
    name: 'jetcards-create',
    component: CreateJetcard,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/jetcards/:id',
    name: 'jetcards-details',
    component: JetcardDetails,
    beforeEnter: ifAuthenticated
  }, 
  {
    path: '/jetcards/:id/modify',
    name: 'jetcards-modify',
    component: ModifyJetcard,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/mobility',
    name: 'mobility',
    component: MobilityCardsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/mobility/create',
    name: 'mobility-create',
    component: CreateMobilityCard,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/mobility/:id',
    name: 'mobility-details',
    component: MobilityCardDetails,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/mobility/:id/modify',
    name: 'mobility-modify',
    component: ModifyMobilityCard,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutView,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: StatisticsPage,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/ai_agents',
    name: 'ai_agents',
    component: PromptsPage,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/intelligence-base',
    name: 'intelligence-base',
    component: IntelligenceBaseList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/intelligence-base/create',
    name: 'intelligence-base-create',
    component: CreateIntelligenceBase,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/intelligence-base/:id/modify',
    name: 'intelligence-base-modify',
    component: ModifyIntelligenceBase,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/clients',
    name: 'clients',
    component: ClientsList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/clients/create',
    name: 'clients-create',
    component: CreateClient,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/clients/:id',
    name: 'clients-details',
    component: ClientDetails,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/clients/:id/missions/create',
    name: 'clients-missions-create',
    component: CreateMission,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/clients/:id/modify',
    name: 'clients-modify',
    component: ModifyClient,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/service-providers',
    name: 'service-providers',
    component: ServiceProvidersList,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/service-providers/create',
    name: 'service-providers-create',
    component: CreateServiceProvider,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/service-providers/:id',
    name: 'service-providers-details',
    component: ServiceProviderDetails,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/service-providers/:id/modify',
    name: 'service-providers-modify',
    component: ModifyServiceProvider,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/legs/:id/modify',
    name: 'legs-modify',
    component: ModifyLeg,
    beforeEnter: ifAuthenticated
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
})

export default router
